import React from 'react'
import MainGrid from './MainGrid'
import CenarioTeste from './Cenarios/CenarioTeste'
import Cenario1 from './Cenarios/Cenario1'
import Cenario2 from './Cenarios/Cenario2'


export const Cenario = ({ idCenario, start, distancesC0, distancesC1, distancesC2, showModal, algorithm }) => { 

    const closeAlert = (id) => {
        document.getElementById(id).setAttribute("style", "display:none");

        // Abaixo vai sumindo mas tem que clicar 2x no X
        // var closebtn = document.getElementsByClassName('closebtn');
        // var i;
        // for (i = 0; i < closebtn.length; i++) {
        //     closebtn[i].onclick = function(){
        //         var div = this.parentElement;
        //         div.style.opacity = "0";
        //         setTimeout(function(){ div.style.display = "none"; }, 600);
        //     }
        // }
    }

    //Fazer nome do algoritmo aparecer formatado
    var currentAlgorithm;
    if(algorithm === 'dijkstra') {
        currentAlgorithm = 'Dijkstra'
    } else if(algorithm === 'astar') {
        currentAlgorithm = 'A* Search'
    } else if(algorithm === 'bfs') {
        currentAlgorithm = 'BFS'
    } else if(algorithm === 'dfs') {
        currentAlgorithm = 'DFS'
    } else if(algorithm === 'bellmanFord') {
        currentAlgorithm = 'Bellman-Ford'
    } else if(algorithm === 'floydWarshall') {
        currentAlgorithm = 'Floyd-Warshall'
    }

    return (
        <>
            <MainGrid>
                {idCenario===0 && <CenarioTeste start={start} distancesC0={distancesC0} showModal={showModal} algorithm={algorithm}/>}
                {idCenario===1 && <Cenario1 start={start} distancesC1={distancesC1} showModal={showModal} algorithm={algorithm}/>}
                {idCenario===2 && <Cenario2 start={start} distancesC2={distancesC2} showModal={showModal} algorithm={algorithm}/>}
                <div id={'alert0'} className="alertc0">
                    <span className="closebtn" onClick={() => {closeAlert('alert0')}} >&times;</span>
                        Select the starting point.
                </div> 
                <div id={'alert1'} className="alertc1">
                    <span className="closebtn" onClick={() => {closeAlert('alert1')}} >&times;</span>
                        Select the starting point.
                </div> 
                <div id={'alert2'} className="alert">
                    <span className="closebtn" onClick={() => {closeAlert('alert2')}} >&times;</span>
                        Select the starting point.
                </div> 
                <div id={'alert-buscando-caminho'} className="alert-buscando-caminho">
                    <span className="closebtn" onClick={() => {closeAlert('alert-buscando-caminho')}} >&times;</span>
                        Looking for the shortest path...
                </div> 
                <div id={'alert-achou-caminho'} className="alert-achou-caminho">
                    <span className="closebtn" onClick={() => {closeAlert('alert-achou-caminho')}} >&times;</span>
                        I found the shortest path!
                </div>
                <div id={'alertAlgorithm'} className="alertAlgorithm">
                    <span className="closebtn" onClick={() => {closeAlert('alertAlgorithm')}} >&times;</span>
                        Current algorithm: {currentAlgorithm}
                </div> 
            </MainGrid>
        </>
    )
}

export default Cenario
